import * as React from 'react'

const SvgContrastIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.356 7.4a8.509 8.509 0 00-.662-1.569 8.75 8.75 0 10.663 1.569zM2.5 10A7.5 7.5 0 0110 2.5v15A7.5 7.5 0 012.5 10z"
      fill="#163250"
    />
  </svg>
)

export default SvgContrastIcon
